<template>
    <div id="infinite-list" class="main-wrapper scroll-y custom-scrollbar with-tabs view-news">

        <page-title :title="title" :back="true"></page-title>

        <div v-for="(item, index) in files" :key="index">
            <item-downloads-file
                    :index="index+1"
                    :slug="item.slug"
                    :image="item.image"
                    :file="item.file"
                    :name="item.name">
            </item-downloads-file>
        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import PageTitle from '@/components/PageTitle.vue';
    import ItemDownloadsFile from '@/items/ItemDownloadsFile.vue';

    export default {
        name: 'DownloadsList',
        components: { PageTitle, ItemDownloadsFile },
        data() {
            return {
                show: false,
                files: [],
                title: "Pliki"
            }
        },
        mounted() {
            this.show = true;
            this.getDownloads()
        },
        methods: {
            // todo refactor to vuex
            getDownloads(){
                api({url: 'downloads?per_page=100', method: 'GET'})
                    .then(resp => {
                        let downloads = resp.data.data;
                        let slug = this.$route.params.slug;
                        // find files
                        let obj = downloads.filter((item) => {
                            return item.slug === slug;
                        });
                        // set page title
                        //this.title = obj[0].name;
                        // append files
                        if(obj.length > 0){
                            this.files = obj[0].files
                        }
                    })
            },
        }

    }
</script>

<style lang="scss" scoped>
    ion-item,
    ion-list {
        --background: #f2f2f2;
    }

    ion-list {
        padding: 0;
        margin: 0;
    }

</style>
